import { ENUM_USER_TYPE } from 'enum/profile';
import { User } from 'stores/UserStore/UserStore.types';


export const isStudioAdminCheck = (user: User): boolean => user && user.accountType === ENUM_USER_TYPE.STUDIO_ADMIN;

export const isStudioOwnerCheck = (user: User): boolean => user && user.accountType === ENUM_USER_TYPE.STUDIO_OWNER;
